import previewAttachment from './previewAttachment.vue'
export default previewAttachment
